import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

// Styles.
import '../scss/formSubmitResponse.scss';

const FormSubmitResponse = ({
  errors,
  status,
}) => {
  if (! errors && ! status) {
    return null;
  }

  return (
    <div className="newsletters__form-submit-response">
      {errors.map((error) => (
        <Fragment key={error}>
          <span
            aria-live="assertive"
            className="newsletters__form-error"
          >
            {error}
          </span>
          &nbsp;
        </Fragment>
      ))}
      {'subscribed' === status ? (
        <div className="newsletters__form-status">
          {/* eslint-disable-next-line max-len */}
          <p>Thanks for connecting with the Kauffman Foundation.<br />Check your inbox to confirm your subscription.</p>
        </div>
      ) : null}
    </div>
  );
};

FormSubmitResponse.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  status: PropTypes.string.isRequired,
};

export default FormSubmitResponse;
